var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightTickMarkLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2422 3.16406C16.2989 3.18432 16.3458 3.21556 16.3828 3.25781C16.3041 3.26788 16.2572 3.23663 16.2422 3.16406Z",
    fill: "#489A3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9711 1.34719C15.3868 1.14941 18.7912 2.88687 21.1843 6.55966C23.1386 10.1406 23.1589 13.7368 21.2449 17.3483C18.8771 21.073 15.4727 22.8408 11.0317 22.6517C6.56706 22.0615 3.5263 19.6674 1.90946 15.4694C0.760481 11.8167 1.3262 8.46294 3.60662 5.40807C5.5347 3.09555 7.98952 1.74194 10.9711 1.34719Z",
    fill: "#F5E6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7315 7.52796C17.2827 7.43965 17.6767 7.64166 17.9134 8.13406C17.9702 8.43123 17.9298 8.7141 17.7922 8.9826C15.6506 11.407 13.5089 13.8314 11.3673 16.2558C10.9749 16.6092 10.5608 16.6395 10.1247 16.3467C8.84172 15.185 7.55879 14.0234 6.2758 12.8617C5.96698 12.2411 6.09827 11.7462 6.66978 11.3767C6.95812 11.3276 7.241 11.3479 7.51836 11.4373C8.5589 12.3566 9.59937 13.2758 10.6399 14.1951C12.4987 12.0939 14.3575 9.99279 16.2163 7.89162C16.3782 7.74603 16.5499 7.62481 16.7315 7.52796Z",
    fill: "#6A097D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTickMarkLight);
export default __webpack_public_path__ + "static/media/rightTickMarkLight.52407f98931544f8037bb55b60952d86.svg";
export { ForwardRef as ReactComponent };